export default "__VITE_ASSET__310cb3e4__"